import { useSaveActions } from "../../common"
import { TableName } from "../../../tables"
import { Vehicle } from "../state/types"

export const useVehicleActions = () => {
    const saveActions = useSaveActions()

    const saveVehicle = (vehicle: Vehicle) => {
        const { save } = saveActions()
        return save(TableName.VEHICLES, vehicle) as Promise<Vehicle>
    }

    const removeVehicle = (id: string) => {
        const { remove } = saveActions()
        return remove(TableName.VEHICLES, id)
    }

    return {
        saveVehicle,
        removeVehicle
    }
}
